import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import useForm from './useForm';
import Table from '../../../components/UI/Table/Table';
import { useTranslation } from 'react-i18next';
import { LinearProgress } from '@material-ui/core';

const ListStudent = (props) => {
  const { displayOptions, role } = props;
  React.useEffect(() => {
    console.log({ props });
  }, [props]);
  const {
    attributes,
    actions,
    listStudent,
    findAllStudents,
    totalPages,
    loading,
    setLoading,
    establishments,
    query,
    establishmentSearch,
    setEstablishmentSearch,
    studentIsActivatedSearch,
    setStudentIsActivatedSearch,
    region,
    setRegion,
  } = useForm(displayOptions);

  const { t, i18n } = useTranslation();

  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title={t('student.title.list')} subtitle={t('student.subTitle')} className="text-sm-left" />
        </Row>
        <Row>
          <Col>
            <Card small className="mb-4">
              <Table
                attributes={attributes}
                actions={actions}
                data={listStudent}
                loading={loading}
                setLoading={setLoading}
                search={findAllStudents}
                numberOfPage={totalPages}
                query={query}
                role={role}
                name={'student'}
                textButton={displayOptions.addButton && t('student.add')}
                linkButton={displayOptions.addButton && '/student/add'}
                establishments={establishments}
                establishmentSearch={establishmentSearch}
                setEstablishmentSearch={setEstablishmentSearch}
                studentIsActivatedSearch={studentIsActivatedSearch}
                setStudentIsActivatedSearch={setStudentIsActivatedSearch}
                region={region}
                setRegion={setRegion}
                pdfTitle="Liste des étudiants"
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ListStudent;
